/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const PLACES_SERVICE = {
    list,
    add,
    edit,
    get,
    updateStatus
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Places";

/* Services */
function list(pageNumber, resultsNumber, searchText, status, orderBy)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetPlacesList"]);    
    var queryParams = {"pageNumber":pageNumber, "resultsNumber":resultsNumber, "searchText":searchText, "status":status, "orderBy": orderBy};
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function add(place, image) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RegisterPlace"]); 
    
    let formData = new FormData();
    formData.append("name", place.name);
    formData.append("notes", place.notes);
    if(image)
    {
        formData.append("photo", image);
    }

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function edit(id, place, image) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdatePlace", id]); 

    let formData = new FormData();
    formData.append("name", place.name);
    formData.append("notes", place.notes);
    if(image)
    {
        formData.append("photo", image);
    }

    const requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function get(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetPlace", id]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateStatus(id, status) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdateStatus", id, status]); 

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}